import { Container, SimpleGrid, Card, Box, Group, Stack, Text, Badge, Button, Space, Center, Divider } from '@mantine/core';
import { modals } from '@mantine/modals';

import { MethodCredentialsCreateForm } from './method-credentials-create-form';
import { MethodCredentialsUpdateForm } from './method-credential-update-form';
import { useDeleteMethodCredential } from '../../hooks/use-delete-method-credential';
import { convertMethodsCredentials } from '../../utils/helpers/converter';

import type { TPaymentMethod, TPaymentMethodCredential } from '../../store/types';

type Props = {
  paymentMethod?: TPaymentMethod | null;
};

export const MethodCredentials = (props: Props) => {
  const {
    paymentMethod,
  } = props;

  const credentialsList = paymentMethod?.credentials;
  const {
    handleSubmit: handleDeleteCredentialsSubmit,
  } = useDeleteMethodCredential();

  if (!paymentMethod || !credentialsList) {
    return (
      <div>Данные не доступны</div>
    );
  }

  const openCreateCredentialsModal = () => modals.open({
    title: 'Добавление реквизитов',
    // centered: true,
    children: (
      <MethodCredentialsCreateForm
        paymentMethod={paymentMethod}
        onClose={modals.closeAll}
      />
    ),
  });

  const openUpdateCredentialsModal = (item: TPaymentMethodCredential) => modals.open({
    title: 'Редактирование реквизитов',
    // centered: true,
    children: (
      <MethodCredentialsUpdateForm
        paymentMethod={paymentMethod}
        onClose={modals.closeAll}
        credentials={item}
      />
    ),
  });

  const openDeleteModal = (item: TPaymentMethodCredential) =>
    modals.openConfirmModal({
      title: `Удаление ID ${item.id}`,
      centered: true,
      children: (
        <Text size="sm">
          Вы точно хотите удалить реквизиты с ID {item.id}?
        </Text>
      ),
      labels: { confirm: 'Удалить', cancel: 'Отмена' },
      confirmProps: { color: 'red' },
      onConfirm: () => handleDeleteCredentialsSubmit({ credentialsId: item.id }),
    });

  return (
    <Container size="100%" pb={30} pl={0} pr={0}>
      <Group justify="space-between">
        <Box>
          <Text>ID платёжного метода: <span style={{ fontWeight: '500' }}>{paymentMethod.id}</span></Text>
          <Text>Название метода: <span style={{ fontWeight: '500' }}>{paymentMethod.name}</span></Text>
        </Box>
        <Button
          variant="filled"
          onClick={openCreateCredentialsModal}>
          Добавить
        </Button>
      </Group>
      <Space h="md" />

      {credentialsList.length === 0 && (
        <Center>Список реквизитов пуст</Center>
      )}

      <SimpleGrid
        cols={{ base: 1, sm: 2, md: 3, lg: 3 }}
        spacing="md"
        style={{ width: '100%' }}
      >
        {convertMethodsCredentials(credentialsList).map((item) => (
          <Card shadow="sm" padding="md" radius="md" withBorder>
            <Card.Section withBorder p="md" pt={10} pb={10} mb={10} bg={'blue.4'} c={'gray.0'}>
              <Group justify="space-between">
                <Text fw={500}>ID реквизитов</Text>
                <Text fw={500}>{item.id}</Text>
              </Group>
            </Card.Section>

            <Stack
              align="stretch"
              justify="flex-start"
              gap="xs"
            >
              {item.fields.map((field) => (
                <Group justify="space-between" gap="xs">
                  <Text fw={300}>{field.name}</Text>
                  <Text fw={400}>{field.value}</Text>
                </Group>
              ))}

              <Divider />
              <Group justify="space-between">
                <Text fw={500}>Способы оплаты:</Text>
                <Group>
                  {item.validFor.map((paySystem) => (
                    <Badge color="gray">{paySystem}</Badge>
                  ))}
                </Group>
              </Group>

              <Divider />
              <Group justify="space-between">
                <Text fw={500}>Лимит</Text>
                <Text fw={300}>{item.limit ?? '-'}</Text>
              </Group>

              <Divider />
              <Group justify="space-between" >
                <Text fw={500}>ID магазина</Text>
                <Text fw={300}>{item.shopId ?? '-'}</Text>
              </Group>

              <Divider />
              <Group justify="space-between" mb={10}>
                <Text fw={500}>Для клиента с ID</Text>
                <Text fw={300}>{item.forPayerId ?? '-'}</Text>
              </Group>

              <Divider />
              <Group justify="space-between" mb={10}>
                <Text fw={500}>Исключить ID клиента</Text>
                <Text fw={300}>{item.exceptPayerId ?? '-'}</Text>
              </Group>
            </Stack>

            <Divider mb={15} />

            <Group justify="flex-end" mt="auto" >
              <Button
                size="xs"
                variant="default"
                onClick={() => openUpdateCredentialsModal(item)}
              >
                Редактировать
              </Button>
              <Button
                color="red"
                size="xs"
                onClick={() => openDeleteModal(item)}
              >
                Удалить
              </Button>
            </Group>
          </Card>

        ))}
      </SimpleGrid>
    </Container>
  );
};
